import React from 'react'
import QuotationManagementPage from './quotation-management-page'

const QuotationBaseDraft = () => {
  return <QuotationManagementPage isBaseDraft={true} />
}

export default QuotationBaseDraft
